import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';
import { Masonry } from 'dc/Masonry';
import ActivityCard from 'challenge/common/ActivityCard';
import { ActivitiesLabel, ActivitiesTitle } from '../elements';
import { ICON } from 'resources/constants';
import { useText } from 'common/hooks';

const deps = {
  popularActivities: state.challenge.log.computedMostPopularActivities,
  organisationName: state.challenge.campaign.organisation.name,
};

function PopularActivities({
  popularActivities,
  organisationName,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  return (
    <>
      <ActivitiesLabel $marginBottom="12px">
        <ActivitiesTitle icon={ICON.star} color={'#ffc107'}>
          {`${t('challenge.ChaPaM21A.popular', {
            organisationName,
          })} (${popularActivities.length})`}
        </ActivitiesTitle>
      </ActivitiesLabel>
      <Masonry
        cards={popularActivities.map(({ activityKey, timesLogged }) => (
          <ActivityCard
            key={activityKey}
            activityKey={activityKey}
            color={'#F5C344'}
            timesLogged={timesLogged}
            className={'grid-item'}
          />
        ))}
      />
    </>
  );
}

export default connect(deps, PopularActivities);
